import React from "react";
import Quote from "./Quote";
import "../index.css";

function QuoteBox() {
  return (
    <div id="quote-box">
      <Quote />
    </div>
  );
}

export default QuoteBox;
